import { useEffect, useState } from "react";
import axios from "axios";

const useFileUploadsFromActiveLicenses = (slug?: string, schoolYear?: string) => {
    const [fileUploadsFromActiveLicenses, setFileUploadsFromActiveLicenses] = useState<any[]>([]);
    const [availableSchoolYears, setAvailableSchoolYears] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const result = await axios.get('/api/v1/syllabus/user_file_upload/active-license-uploads/', {
                    headers: {
                        'X-CSRFToken': JSON.parse(
                            document.getElementById('csrf_token')!.innerHTML,
                        ),
                    },
                    params: {
                        slug,
                        school_year: schoolYear
                    }
                });
                if (result.data) {
                    const sorted = result.data.results
                        .sort((a: any, b: any) => (a.actual_student_school_name || '').localeCompare(b.actual_student_school_name || ''));
                    setFileUploadsFromActiveLicenses(sorted);
                    setAvailableSchoolYears(result.data.available_school_years || []);
                }
            } catch (error) {
                console.error("Error fetching file uploads:", error);
                setError("Error fetching file uploads - " + JSON.stringify(error));
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [slug, schoolYear]);

    return {
        fileUploadsFromActiveLicenses,
        availableSchoolYears,
        isLoading,
        error
    };
};

export default useFileUploadsFromActiveLicenses;
